export enum EnumAppSignatureType {
  PARENT = 'parent',
  CHILD = 'child',
  MENTION = 'mention',
  PURCHASER = 'purchaser',
  CERTIFICATION = 'certification',
  AGREEMENT = 'agreement'
}

export enum EnumAppSignatureDisplayText {
  PARENT = 'Parent/Guardian Non-Purchaser Certification',
  PURCHASER = 'Account Owner Purchaser Certification',
  CERTIFICATION = 'Application Certification',
  AGREEMENT = 'Participation Consent, Liability Release and Indemnity Agreement'
}

export enum EnumProfileType {
  CHILD = 'child',
  PARENT = 'parent'
}

export enum EnumSections {
  CHILD = 'child',
  ESSAY = 'essay',
  TRANSCRIPT = 'transcript',
  FINANCIAL = 'financial',
  META = 'meta',
  PARENT = 'parent',
  SIGNATURE = 'signature',
  SIGNATURES = 'signatures',
  TTPF = 'ttpf',
  SUBMIT = 'submit'
}
export enum EnumFileStatus {
  FAILED = 'failed',
  PENDING = 'pending',
  MALICIOUS = 'malicious',
  RECEIVED = 'received',
  DELETED = 'deleted'
}
export enum EnumAppSignatureFormat {
  DIGITAL = 'digital',
  PAPER = 'paper'
}

export enum EnumHasScholarship {
  YES = 'yes',
  NO = 'no'
}

export enum EnumHearAboutSurvey {
  ARTICLE = 'article',
  EMAIL = 'email',
  EVENT = 'event',
  FACEBOOK = 'facebook',
  INTERVIEW = 'interview',
  PERSON = 'person',
  TWITTER = 'twitter',
  OTHER = 'other',
  WEB = 'web'
}

export interface MAppSignature {
  id?: string;
  customEmailBody?: string;
  docStatus?: EnumFileStatus | undefined;
  email?: string;
  filePath?: string | undefined;
  firstName: string | null;
  lastName: string | null;
  linkedSignatureProfile?: string;
  signed: boolean | null;
  signedAgreementWording?: string | null;
  signatureFormat: EnumAppSignatureFormat | null;
  signatureType: EnumAppSignatureType | null;
  signatureId?: string;
  userId?: string;
}

export interface MAppEssay {
  docContent?: string | undefined;
  docFormat: EnumAppDocFormat | undefined;
  docStatus: EnumFileStatus | undefined;
  docType: EnumAppDocType | undefined;
  filePath?: string | undefined;
}

export interface MAppTranscript {
  docContent?: string | undefined;
  docFormat: EnumAppDocFormat.FILE;
  docStatus: EnumFileStatus | undefined;
  docType: EnumAppDocType.TRANSCRIPT;
  filePath?: string | undefined;
}

export interface MAppFinancial {
  dependents: number;
  id: string;
  income: number;
  sk: string;
  userId: string;
}

export enum EnumProfileRelation {
  FATHER = 'father',
  MOTHER = 'mother',
  OTHER = 'legal guardian'
}

export enum EnumAppType {
  GRANT = 'grant',
  SCHOLARSHIP = 'scholarship'
}

export enum EnumAppDocFormat {
  FILE = 'file',
  TEXT = 'text'
}

export enum EnumAppDocType {
  ESSAY = 'essay',
  TRANSCRIPT = 'transcript',
  SIGNATURE = 'signature'
}

export enum EnumAppStatus {
  APPROVED = 'approved',
  DENIED = 'denied',
  DISMISSED = 'dismissed',
  PENDING = 'pending',
  INCOMPLETE = 'incomplete'
}

export enum EnumAppSubmitted {
  YES = 'yes',
  NO = 'no'
}

export interface MApplication {
  id: string;
  meta: MAppMeta;
  ttpf: MAppTtpf;
  financial: { dependents: number; income: number };
  essay: MAppEssay;
  transcript: MAppTranscript;
  signatures: MAppSignature[];
}

export interface MAppTtpf {
  id?: string;
  ttpfParentSignature: MAppSignature;
  ttpfPurchaserSignature?: MAppSignature;
  notParentTtpfAccount: boolean | null;
  ttpfId: string;
  ttpfOwnerFirstName: string;
  ttpfOwnerLastName: string;
  checked?: boolean;
}

export interface MAppMeta {
  id: string;
  appType?: EnumAppType;
  status: EnumAppStatus;
  submitted: EnumAppSubmitted;
  submittedTimestamp?: string;
  userId?: string;
  year: number;
  firstName?: string;
  lastName?: string;
  lastUpdated?: number;
  linkedChildProfile: string;
  linkedParentProfile: string;
  progress: object;
}

export interface MProfile {
  id: string;
  address1: string;
  address2?: string;
  addressCity: string;
  addressState: string;
  addressZip: string;
  addressCounty: string;
  addressCountry: string;
  hasScholarship: string;
  hasMailingAddress: boolean;
  mailing1?: string;
  mailing2?: string;
  mailingCity?: string;
  mailingCounty?: string;
  mailingState?: string;
  mailingZip?: string;
  mailingCountry?: string;
  dob: Date | string | null;
  firstName: string;
  grade: number;
  lastName: string;
  userId: string;
  email: string;
  otherRelationship?: string;
  phone: string;
  relationship?: EnumProfileRelation | string;
  lastUpdated?: number;
}
